import { useContext } from "react";
import { BrandingContext } from "./BrandingContextValue";
import type { BrandingContextValue } from "../types";

export function useBranding(): BrandingContextValue {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error("useBranding must be used within BrandingProvider");
  }
  return context;
}
